module.exports = __webpack_public_path__ + "img/logo4.1c3e0ea1.png";